import { ConversionError } from '../../error/ConversionError';
import { AbstractIOConverter } from '../module';
/**
 * Convert UNIX timestamps (in seconds) to date string
 *
 * Rejects converting invalid timestamps (that result in invalid dates)
 *
 * @example
 * '1578408431' => '2020-01-07T14:47:11.000Z'
 */
export class UTCUnixToDate extends AbstractIOConverter {
    static toServerFormat(input) {
        // Do not handle null or undefined input
        if (input === null) {
            return null;
        }
        if (typeof input === 'undefined') {
            return undefined;
        }
        // Determine if we're handling a date or ISO string. In any case, set the correct date.
        let date;
        if (typeof input === 'string') {
            date = new Date(input);
            if (isNaN(date.getTime())) {
                throw new ConversionError(`Input date ("${input}") can't be converted to a valid timestamp!`, 'toServer');
            }
        }
        else {
            date = input;
        }
        // Drop the milliseconds as the server doesn't care and only takes seconds
        const timestampSeconds = Math.floor(date.getTime() / 1000);
        if (isNaN(timestampSeconds)) {
            throw new ConversionError(`Input date ("${input}") can't be converted to a valid timestamp!`, 'toServer');
        }
        return timestampSeconds;
    }
    static toClientFormat(inputSeconds) {
        // Do not handle null or undefined input
        if (inputSeconds === null) {
            return null;
        }
        if (typeof inputSeconds === 'undefined') {
            return undefined;
        }
        // If output from server is malformed, this date will display 'Invalid Date'
        const date = new Date(inputSeconds * 1000);
        if (isNaN(date.getTime())) {
            throw new ConversionError(`Timestamp "${inputSeconds}" can't be converted to a valid date!`, 'toClient');
        }
        return date.toISOString();
    }
}
